/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Full_Art_BarInputs */

const en_services_svc_full_art_bar = /** @type {(inputs: Services_Svc_Full_Art_BarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`System monitor`)
};

const lv_services_svc_full_art_bar = /** @type {(inputs: Services_Svc_Full_Art_BarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistēmas uzraudzība`)
};

/**
* | output |
* | --- |
* | "System monitor" |
*
* @param {Services_Svc_Full_Art_BarInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_full_art_bar = /** @type {((inputs?: Services_Svc_Full_Art_BarInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Full_Art_BarInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_full_art_bar(inputs)
	return en_services_svc_full_art_bar(inputs)
});